import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { PageLoading } from '@vyce/core/src/components/PageLoading';
import { FormConstructor } from './FormConstructor';
import { useFormRouteSegment } from './hooks/useFormRouteSegment';
import { useFormData } from './hooks/useFormData';
import { CenteredFormMessage } from './components/CenteredFormMessage';
import { Team, TimeAndAttendanceLocation, User } from '../../types';

export const ExistingForm: React.FC<{
  user: User;
  companyId: string;
  locations: TimeAndAttendanceLocation[];
  teams?: Team[];
}> = ({ user, companyId, locations, teams = [] }) => {
  const { id: formId } = useFormRouteSegment('id');
  const { search } = useLocation();
  const openSend = new URLSearchParams(search).get('openSend') === 'true';
  const { form, loading, getForm } = useFormData({ userId: user.uuid, companyId });

  useEffect(() => {
    if (formId) {
      getForm(formId);
    }
  }, [formId]);

  if (loading) {
    return <PageLoading />;
  }

  if (!form) {
    return <CenteredFormMessage>Form not found</CenteredFormMessage>;
  }

  return (
    <FormConstructor
      form={form}
      user={user}
      companyId={companyId}
      locations={locations}
      teams={teams}
      initialSelectRecipientsOpen={openSend}
    />
  );
};
